
import React from 'react';
import { Caption1Bold, Caption2Bold } from '../../../config/designSystem/typography';
import { GradientView } from '../../Gradients/GradientView';
import { SPACING } from '../../../config/designSystem/Spacing';
import { View } from 'react-native';
import { useBreakpointWidth } from '../../../hooks/useBreakpointWidth';
import { useStores } from '../../../hooks/useStores';

interface ResultBarProps {
    featureId: string;

}

export const ResultBar = ({ featureId }: ResultBarProps) => {
  const rootStore = useStores();
  const feature = rootStore?.feature.getFeature(featureId);


  const WIDTH = useBreakpointWidth({lg: 200, md: 150, sm: 100});
  const SIZE_ICON = 20;
  if(!feature || !('value' in feature) || !('minValue' in feature) || !('maxValue' in feature) )return;

  const value = feature?.value || 0;
  const minValue = feature?.minValue || 0;
  const maxValue = feature?.maxValue || 10;
  const left = (WIDTH*(value- minValue)/(maxValue-minValue));
  const HEIGHT = 16;
  return (
    <View style={{alignItems: 'center'}}>
      <View style={{flexDirection:'row', alignItems: 'center', columnGap: SPACING['sp-16']}}>
        <View >
          <Caption2Bold>{minValue}</Caption2Bold>
        </View>
        <View>
          <GradientView gradient={{left: 'red', right: 'lightgreen', orientationAngle:90}}  >
            <View style={{ width: WIDTH, height: HEIGHT}} >
              <View style={{width: 2, height: HEIGHT, backgroundColor: 'black',
                left
              }} />
            </View>

          </GradientView>
          <View style={{
            position:'absolute',
            marginLeft: left - 5,
            alignItems: 'center',
            marginTop: HEIGHT}}>
            <Caption1Bold>{value}</Caption1Bold>
          </View>
        </View>
        <View >
          <Caption1Bold>{maxValue}</Caption1Bold>
        </View>
      </View>


    </View>
  );
};


